import React from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import RaisedButton from 'material-ui/RaisedButton';
import styls from './styles.css'
import homeIcon from './icon/house.png'
import placeIcon from './icon/004-map-location.png'
import foodIcon from './icon/store.png'
import shoppingIcon from './icon/shopping-bag.png'
import otopIcon from './icon/002-online-shop.png'
import hotelsIcon from './icon/hotel.png'
import newsIcon from './icon/001-text-lines.png'

import language from '../../../config/language'

const FilterBox = ({ match, lang, location: { pathname } }) => {
  const {
    home,
    place,
    food,
    shopping,
    otop,
    hotels,
    news,
    bookmark
  } = language[lang].menu
  console.log('path', pathname)
  return (
  <div className="filterBox">
    <div className={"wrapperLink " + (pathname !== '/home' && pathname !== '/' ? "faded" : "")}>
      <Link className="link home" to={`/home`}>
        <img src={homeIcon} />
      </Link>
      <p>{home}</p>
    </div>
    <div className={"wrapperLink " + (pathname !== '/home/place' ? "faded" : "")}>
      <Link className="link place" to={`/home/place`}>
        <img src={placeIcon} />
      </Link>
      <p>{place}</p>
    </div>
    <div className={"wrapperLink " + (pathname !== '/home/shopping' ? "faded" : "")}>
      <Link className="link shopping" to={`/home/shopping`}>
       <img src={shoppingIcon} />
      </Link>
      <p>{shopping}</p>
    </div>
    <div className={"wrapperLink " + (pathname !== '/home/food' ? "faded" : "")}>
      <Link className="link food" to={`/home/food`}>
        <img src={foodIcon} />
      </Link>
      <p>{food}</p>
    </div>
    <div className={"wrapperLink " + (pathname !== '/home/hotels' ? "faded" : "")}>
      <Link className="link hotels" to={`/home/hotels`}>
        <img src={hotelsIcon} />
      </Link>
      <p>{hotels}</p>
    </div>
    <div className={"wrapperLink " + (pathname !== '/home/otop' ? "faded" : "")}>
      <Link className="link otop" to={`/home/otop`}>
       <img src={otopIcon} />
      </Link>
      <p>{otop}</p>
    </div>
    <div className={"wrapperLink " + (pathname !== '/home/news' ? "faded" : "")}>
      <Link className="link news" to={`/home/news`}>
        <img src={newsIcon} />
      </Link>
      <p>{news}</p>
    </div>
    <div className={"wrapperLink faded"}>
      <Link className="link news" to={`/bookmark`}>
        <i style={{ fontSize: 52 }} className={"material-icons icon isFollow"}>{'favorite'}</i>
      </Link>
      <p>{bookmark}</p>
    </div>
  </div>
);}

export default withRouter(connect(({ lang }) => ({ lang }))(FilterBox))


// WEBPACK FOOTER //
// ./src/containers/Home/common/FilterBox.js